"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.humanReadableScore = humanReadableScore;
exports.getResults = getResults;
exports.getScales = getScales;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.ORS;
var ors = ["Low", "", "", "", "", "", "", "", "", "High"];
var humanReadableScales = "Low - 1, High - 10";
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  extraText: "In the past week,",
  type: "ors",
  options: ors
};
var orsQuestions = [// ORS Questions
{
  prompt: "how have you been feeling personally?"
}, {
  prompt: "how have you been feeling about things outside of work?"
}, {
  prompt: "how have you been feeling about things at work?"
}, {
  prompt: "how would you rate your overall sense of wellbeing?"
}];
var questions = (0, _utils.wrapBattery)(orsQuestions, baseProps);
exports.questions = questions;

function humanReadableScore(orsScore) {
  var summaryString = "Very Low";

  if (orsScore > 27) {
    summaryString = "Low";
  }

  if (orsScore > 50) {
    summaryString = "Average";
  }

  if (orsScore > 70) {
    summaryString = "High";
  }

  if (orsScore > 85) {
    summaryString = "Very High";
  }

  return summaryString;
}

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers) * 4);
  var humanReadable = {
    ORS: "".concat(score, " (").concat(humanReadableScore(score), ")")
  };
  questions.forEach(function (q, i) {
    humanReadable[q.prompt] = answers[i];
  });
  return {
    ORS: score,
    humanReadable: humanReadable
  };
}

function getScales() {
  var scales = {
    ORS: "Very Low (0-27), Low (28-50), Average (51-70), High (71-85), Very High (86-100)"
  };
  questions.forEach(function (q) {
    scales[q.prompt] = humanReadableScales;
  });
  return scales;
}